import React ,{Component} from 'react';
import { BrowserRouter as Router, Route, HashRouter,Routes,NavLink, } from 'react-router-dom';
import './components/styles/styles.css';

import Businessform from "./components/Businessform";
import Productlist from "./components/Productlist";
import Addproduct from "./components/Addproduct";

import Termsandconditions from "./components/Termsandconditions";
import AddTerms from "./components/AddTerms";
import Businesslogin from "./components/Businesslogin";
import Customerlist from "./components/Customerlist";
import AddCustomer from "./components/AddCustomer";
import Makequote from "./components/Makequote";
import QuoteSelectorPanel from "./components/QuoteSelectorPanel";
import AppLayout from "./components/AppLayout";
import Quotationlist from "./components/Quotationlist";
import { Navigate  } from 'react-router-dom';
import Purchaseorder from "./components/Purchaseorder";
import Logout from "./components/Logout";
import Businesschangepassword from "./components/Businesschangepassword";
import Dashboard from "./components/Dashboard";
import Signup from "./components/Signup";

import Makepurchase from "./components/Makepurchase";


import Loginlayout from "./components/Loginlayout";
import Settingspage from "./components/Settingspage";
import QuotationSetting from "./components/QuotationSetting";
import PurchaseorderSetting from "./components/PurchaseorderSetting";
import InvoiceSetting from "./components/InvoiceSetting";
import PurchaseView from "./components/PurchaseView";
import QuotationView from "./components/QuotationView";
import Profile from "./components/Profile";
import Contactus from "./components/Contactus";

import Makeinvoice from "./components/Makeinvoice";
import InvoiceView from "./components/InvoiceView";
import Invoicelist from "./components/Invoicelist";


class App extends Component {
render() {
	const isLoggedIn = localStorage.getItem("GBname");
    return ( 
	
	<Router basename="/">
	 
        <Routes>

          {/* Login Layout */}
          <Route element={<Loginlayout />}>
            <Route
  path="/"
  element={
    isLoggedIn
      ? <Navigate to="/Dashboard" replace />
      : <Navigate to="/Businesslogin" replace />
  }
/>
            <Route
  path="/Businesslogin"
  element={
    isLoggedIn
      ? <Navigate to="/Dashboard" replace />
      : <Businesslogin />
  }
/>
            <Route path="/Signup" element={<Signup />} />
            <Route path="/Logout" element={<Logout />} />
			<Route path="/purchase/view/:id" element={<PurchaseView />} />
			<Route path="/quotation/view/:id" element={<QuotationView />} />
				<Route path="/invoice/view/:id" element={<InvoiceView />} />
			
          </Route>

          {/* Main Application Layout */}
          <Route element={<AppLayout />}>
            <Route path="/Dashboard" element={<Dashboard />} />
            
            <Route path="/Businessform" element={<Businessform />} />
            <Route path="/Productlist" element={<Productlist />} />
            <Route path="/Addproduct" element={<Addproduct />} />
            
            <Route path="/Termsandconditions" element={<Termsandconditions />} />
            <Route path="/AddTerms" element={<AddTerms />} />
            <Route path="/Customerlist" element={<Customerlist />} />
            <Route path="/AddCustomer" element={<AddCustomer />} />
           
            <Route path="/Makequote" element={<Makequote />} />
            <Route path="/QuoteSelectorPanel" element={<QuoteSelectorPanel />} />
            <Route path="/Quotationlist" element={<Quotationlist />} />
            <Route path="/Purchaseorder" element={<Purchaseorder />} />
            <Route path="/Makepurchase" element={<Makepurchase />} />
			
			<Route path="/Makeinvoice" element={<Makeinvoice />} />
			<Route path="/Invoicelist" element={<Invoicelist />} />

			
			<Route path="/Settings" element={<Settingspage />} />
			<Route path="/QuotationSetting" element={<QuotationSetting />} />
			<Route path="/PurchaseorderSetting" element={<PurchaseorderSetting />} />
			<Route path="/InvoiceSetting" element={<InvoiceSetting />} />
			<Route path="/Profile" element={<Profile />} />
			<Route path="/Contactus" element={<Contactus />} />
			<Route
              path="/Businesschangepassword"
              element={<Businesschangepassword />}
            />
			
          
           
          </Route>

        </Routes>
      </Router>
)}
}
export default App;
